<template>
    <div id="attribute-form">
        <div class="form-group">
            <font-field v-if="type==='text'||type==='title'||type==='digest'||type==='advertuser'"/>
            <align-field v-if="type==='text'||type==='title'||type==='digest'||type==='advertuser'"/>
            <!--<word-space-field v-if="type==='text'"/>-->
            <color-field v-if="type==='text'||type==='title'||type==='digest'||type==='advertuser'"/>
            <!--<opacity-field v-if="type==='text'||type==='image'"/>-->
            <size-field v-if="type" :ratio="selected.width/selected.height"/>
            <rotate-field v-if="type"/>
            <type-field v-if="type"/>
            <dynamic-field v-if="type" :isDynamic="selected.isDynamic"/>
            <cover-field  v-if="(type==='image'||type==='logo'||type==='icon')" :isCover="selected.isCover"/>
            <image-field v-if="(type==='image'||type==='logo'||type==='icon')"/>
        </div>
    </div>
</template>

<style lang="scss" scoped>
</style>

<script>
	import OpacityField from 'components/field/OpacityField'
	import AlignTextField from 'components/field/AlignTextField'
	import RotateField from 'components/field/RotateField'
	import SizeField from 'components/field/SizeField'
	import ColorField from 'components/field/ColorField'
	import BackgroundColorField from 'components/field/BackgroundColorField'
	import FontField from 'components/field/FontField'
	import LineHeightField from 'components/field/LineHeightField'
	import WordSpaceField from 'components/field/WordSpaceField'
	import ImageField from 'components/field/ImageField'
	import TypeField from 'components/field/TypeField'
	import DynamicField from 'components/field/DynamicField'
	import CoverField from 'components/field/CoverField'

	export default {
		components: {
			'align-field': AlignTextField,
			// 'opacity-field': OpacityField,
			'rotate-field': RotateField,
            'size-field': SizeField,
			'color-field': ColorField,
			// 'background-color-field': BackgroundColorField,
			'font-field': FontField,
			// 'line-height-field': LineHeightField,
			// 'word-space-field': WordSpaceField,
            'image-field': ImageField,
            'type-field': TypeField,
			'dynamic-field': DynamicField,
            'cover-field': CoverField
		},
		computed: {
			type() {
				return this.$store.state.selected.type
			},
			selected() {
				return this.$store.state.selected
			}
		}
	}
</script>
